import styled, { keyframes } from 'styled-components';

import { SpinnerXLIcon } from 'assets/icons';

const themes = {
  1: {
    colorIcon: 'var(--color-black)',
  },
  2: {
    colorIcon: 'var(--color-white)',
  },
  3: {
    colorIcon: 'var(--color-black_50)',
  },
};

const sizes = {
  s: {
    spinnerSize: '14px',
  },
  m: {
    spinnerSize: '20px',
  },
  l: {
    spinnerSize: '28px',
  },
  xl: {
    spinnerSize: '36px',
  },
};

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Container = styled.span`
  --color-icon: ${(p) => (themes[p.theme] || themes['1']).colorIcon};
  --size: ${(p) => (sizes[p.size] || sizes['m']).spinnerSize};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: var(--size);
  height: var(--size);
  animation: ${rotate} ${(p) => p.speed} linear infinite;
`;

export const SpinnerIconWrapper = styled.span`
  width: 100%;
  height: 100%;
`;

export const SpinnerIcon = styled(SpinnerXLIcon)`
  display: block;
  width: 100%;
  height: 100%;
  fill: var(--color-icon);
`;
